<template>
  <v-container fluid fill-height class="report-container" id="print-section">
        <v-card flat class="pa-0 ma-0">
          <v-toolbar color="white" flat>
            <v-img height="120px" left contain :src="`${appUrl}/storage/img/logo_columbus_2.png`"></v-img>
            <v-spacer></v-spacer>
            <h3 v-if="Object.keys(assemblyData).length > 0" class="title font-weight-bold">Reporte | {{ assemblyData.description }}</h3>
          </v-toolbar>
          <v-card-text v-if="!not_virtual" class="pa-0">
            <v-layout v-if="Object.keys(assemblyData).length == 0 && isLoading">
              <v-alert 
                :value="true" color="info" icon="hourglass_empty" outline>
                Cargando datos de la Asamblea...
              </v-alert>
            </v-layout>
            <v-layout v-else-if="!!assemblyData && !isLoading" class="grey lighten-4 mt-3 pa-3" :key="counter+'assembly-data'" row wrap>
              <v-flex v-if="assemblyData.assembly_date" md4 lg4 xl4 class="pa-1" >
                <b>Fecha asamblea:</b> {{ assemblyData.assembly_date }} {{ assemblyData.assembly_time.substring(0,5) }} 
                <!-- <span v-if="assemblyData.assembly_time" md12 lg12 xl12 class="pa-1" :class="diffAssembly[0] == '+'? 'red--text' : ''" >({{ showCounter(assemblyData.assembly_date+' '+assemblyData.assembly_time) }})</span>
                <span v-if="assemblyData.assembly_finish_time" class="font-weight-bold" :class="leftTime >= 0 ? 'red--text' : ''"> a {{ assemblyData.assembly_finish_time.substring(0,5) }} ({{ showCounter(assemblyData.assembly_date+' '+assemblyData.assembly_finish_time.substring(0,5), true) }})</span>
                <span v-if="diffAssembly[1] != '0' && diffAssembly[0] == '+'" class='red--text'>La asamblea finalizó {{ formatTime(diffAssembly) }}</span>
                <span v-if="diffAssembly[0] == '-'" class='red--text'>La asamblea aún no sucede</span> -->
              </v-flex>
              <v-flex v-if="assemblyData.assembly_date" md4 lg4 xl4 class="pa-1" >
                <b>1<sup>a</sup> convocatoria:</b> {{ assemblyData.first_call_time.substring(0,5) }} <!--<span :class="diffSecondCall[0] == '-' && diffFirstCall[0] == '+' ? 'red--text' : ''">({{ showCounter(assemblyData.assembly_date+' '+assemblyData.first_call_time)  }})</span> -->
              </v-flex>
              <v-flex v-if="assemblyData.assembly_date" md4 lg4 xl4 class="pa-1" >
                <b>2<sup>a</sup> convocatoria:</b> {{ assemblyData.second_call_time.substring(0,5) }} <!--<span :class="diffSecondCall[0] == '+' ? 'red--text' : ''">({{ showCounter(assemblyData.assembly_date+' '+assemblyData.second_call_time)  }}) </span> -->
              </v-flex>

            </v-layout>

            <v-flex md12 class="body-2 text-xs-center pa-2">Hora impresión: {{ (new Date).toLocaleString() }}</v-flex>
            <v-divider></v-divider>  
            
                <h2 class="headline ml-3 my-3"><v-icon color="grey lighten-1" medium>pie_chart</v-icon> Gráficos</h2>
                <v-card flat class="mt-2">
                  <v-flex class="pa-2 text-md-center no-break">
                      <v-chip color="blue" dark class="title mb-3">
                        <v-icon left color="white">supervised_user_circle</v-icon> General    
                      </v-chip>
                      
                      <v-flex v-if="assemblyData.first_call_time" :key="counter+'conv1'" md12 lg12 xl12 :class="diffSecondCall[0] == '+' ? 'grey--text' : ''" >
                        1<sup>a</sup> convocatoria - Quórum mínimo {{ new Intl.NumberFormat("en-US").format(assemblyData.min_percentage_first_call) }}%+1 ({{ total_atendance }} de {{ parseInt(total_active_families * assemblyData.min_percentage_first_call / 100, 0)+1 }})
                      </v-flex>
                      <v-flex v-if="assemblyData.second_call_time" :key="counter+'conv2'" md12 :class="diffSecondCall[0] == '-' ? 'grey--text' : ''" >
                        2<sup>a</sup> convocatoria - Quórum mínimo {{ new Intl.NumberFormat("en-US").format(assemblyData.min_percentage_second_call) }}% ({{ total_atendance }} de {{ parseInt(total_active_families * assemblyData.min_percentage_second_call / 100, 0) }})
                      </v-flex>

                      <v-layout justify-center row wrap v-if="Object.keys(assemblyQuorum).length > 0" class="py-3">
                        <div v-for="(chart, index) in circleCharts"
                          :key="index"
                          >
                          <v-flex 
                            v-if="chart.filter == 'all'"
                            style="width: 120px;" 
                            class="text-xs-center"
                            transition="slide-x-transition"
                            >
                            <v-sheet
                              v-if="chart.type == 'circle'"
                              :elevation="0"
                              class="mx-auto no-break"
                              height="140"
                              width="120"
                            >
                              <div><span>{{ chart.title }}</span></div>
                              <v-progress-circular
                                :rotate="-90"
                                :size="90"
                                :width="15"
                                :value="chart.value"
                                :color="chart.color"
                              >
                                {{ chart.value }}
                              </v-progress-circular>
                              <div v-if="chart.subtitle" class="subheading pa-1">
                                {{ chart.subtitle }}
                              </div>
                            </v-sheet>
                            <v-sheet
                                v-else
                                :elevation="0"
                                class="pt-3 mx-auto no-break"
                                height="70"
                                width="120"
                              >
                                <v-icon v-if="chart.icon" color="grey lighten-1" class="ma-2" style="font-size: 40px">{{ chart.icon }}</v-icon>
                                <div>{{ chart.title }}</div>
                                <div v-if="chart.value" class="subheading pa-1">
                                  {{ chart.value }}
                                </div>
                              </v-sheet>
                          </v-flex>
                        </div>
                      </v-layout>                    
                  </v-flex>
                  
                  <v-flex class="pa-2 text-md-center no-break">

                      <v-chip color="orange" dark class="title mb-3">
                        <v-icon left color="white">security</v-icon> ASOPAF    
                      </v-chip>
                      
                      <v-flex v-if="assemblyData.first_call_time" :key="counter+'conv21'" md12 lg12 xl12 :class="diffSecondCall[0] == '+' ? 'grey--text' : ''" >
                        1<sup>a</sup> convocatoria - Quórum mínimo {{ new Intl.NumberFormat("en-US").format(assemblyData.min_percentage_first_call) }}%+1 ({{ total_asopaf_assistance }} de {{ parseInt(total_active_asopaf_families * assemblyData.min_percentage_first_call / 100, 0)+1 }})
                      </v-flex>
                      <v-flex v-if="assemblyData.second_call_time" :key="counter+'conv22'" md12 :class="diffSecondCall[0] == '-' ? 'grey--text' : ''" >
                        2<sup>a</sup> convocatoria - Quórum mínimo {{ new Intl.NumberFormat("en-US").format(assemblyData.min_percentage_second_call) }}% ({{ total_asopaf_assistance }} de {{ parseInt(total_active_asopaf_families * assemblyData.min_percentage_second_call / 100, 0) }})
                      </v-flex>
                      

                      <v-layout justify-center row wrap v-if="Object.keys(assemblyQuorum).length > 0" class="py-3">
                        <div v-for="(chart, index) in circleCharts"
                          :key="index"
                          >
                          <v-flex 
                            v-if="chart.filter == 'asopaf'"
                            style="width: 120px;" 
                            class="text-xs-center"
                            transition="no-break"
                            >
                            <v-sheet
                              v-if="chart.type == 'circle'"
                              :elevation="0"
                              class="mx-auto"
                              height="140"
                              width="120"
                            >
                              <div><span>{{ chart.title }}</span></div>
                              <v-progress-circular
                                :rotate="-90"
                                :size="90"
                                :width="15"
                                :value="chart.value"
                                :color="chart.color"
                              >
                                {{ chart.value }}
                              </v-progress-circular>
                              <div v-if="chart.subtitle" class="subheading pa-1">
                                {{ chart.subtitle }}
                              </div>
                            </v-sheet>
                            <v-sheet
                                v-else
                                :elevation="0"
                                class="pt-3 mx-auto no-break"
                                height="70"
                                width="120"
                              >
                                <v-icon v-if="chart.icon" color="grey lighten-1" class="ma-2" style="font-size: 40px">{{ chart.icon }}</v-icon>
                                <div>{{ chart.title }}</div>
                                <div v-if="chart.value" class="subheading pa-1">
                                  {{ chart.value }}
                                </div>
                              </v-sheet>
                          </v-flex>
                        </div>
                      </v-layout>
                  </v-flex>
                </v-card>
              
                <v-divider class="mt-4"></v-divider>
                <v-card flat class="mt-2" v-if="Object.keys(assemblyQuestions).length > 0">              
                  <h2 class="headline ml-3 my-3"><v-icon color="grey lighten-1" medium>quiz</v-icon> Preguntas</h2>
                  <v-layout row wrap>
                    <v-flex v-if="assemblyData && !isLoading && assemblyQuestions.length == 0">
                      <v-card v-if="!pageLoading" elevation-1>
                        <v-card-text>
                          No hay respuestas registradas para esta asamblea.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <div
                      v-for="(question, index) in assemblyQuestions" 
                      :key="`question-${index}`"
                      xs12 md12 lg12
                      class="question-card mt-4"
                      style="width:100%"
                      >
                      <v-card 
                        elevation-0
                        class="ma-2 text-xs-left no-break"
                        >
                        <v-card-title class="title pb-0">
                          <div>{{ index+1 }} - {{ question.name }} 
                            <span v-if="question.attachment_url" class="d-inline cursor-help" title="tiene adjunto"><v-icon class="blue--text">attach_file</v-icon></span>
                            <span v-if="question.target_audience != 'GENERALPUBLIC'" class="d-inline cursor-help" title="Para grupo cerrado"><v-icon class="orange--text">security</v-icon></span>
                            <span v-if="!!question.active_date" class="d-inline cursor-help pink--text body-1" title="Ya fue publicada">{{ getTotalAnswer(question.id) }} de {{ assemblyQuorum[question.target_audience] }}</span>
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <div>
                            <b>{{ question.description }}</b>
                            <ul v-if="question.question_type != 'YESNO' ">
                              <li
                                v-for="detail in question.question_detail"
                                :key="`question-${index}-${detail.id}`"
                              >
                                {{ detail.text }} <div style="float:right; margin-right: 5px;" v-html="getAnswer(question.id, detail.id)"></div>
                              </li>
                            </ul>
                            <ul v-else>
                              <li>Si <div style="float:right; margin-right: 5px;" v-html="getAnswer(question.id, 'YES')"></div></li>
                              <li>No <div style="float:right; margin-right: 5px;" v-html="getAnswer(question.id, 'NO')"></div></li>
                            </ul>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          {{ question.active_date ? question.active_date.substr(0,16) : 'Sin iniciar' }}
                          {{ question.deactive_date && question.active_date ? ' a '+question.deactive_date.substr(11,5) : '' }}
                        </v-card-actions>
                      </v-card>
                      <v-data-table
                        v-if="Object.keys(answersDetail).length > 0 && getAnswerDetail(question.id).length > 0"
                            :headers="answer_headers"
                            :items="getAnswerDetail(question.id)"
                            :loading="isLoading"
                            :items-per-page="10000"
                            item-key="family_code"
                            :rows-per-page-text="$t('datatable.rowsPerPageText')"
                            :no-results-text="$t('datatable.noResultsText')"
                            :no-data-text="$t('datatable.noDataText')"
                            :rows-per-page-items="[{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
                            hide-actions
                          >
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item.family_code }} - {{ props.item.name }}</td>
                              <td class="text-xs-center">
                                <v-icon v-show="props.item.asopaf === 1" small class="green--text text--lighten-2">check_circle</v-icon>
                              </td>
                              <td class="text-xs-center">
                                <v-icon v-show="props.item.employee === 1" small class="green--text text--lighten-2">check_circle</v-icon>
                              </td>
                              <td class="text-xs-center">{{ props.item.family_agent_code }}</td>
                              <td class="text-xs-center">{{ props.item.answer == 'YES' ? 'SI' : props.item.answer }}</td>
                              <td class="text-xs-center">{{ props.item.created_at.substring(0,16) }}</td>
                            </template>
                          </v-data-table>
                        <v-flex v-if="getAnswerDetail(question.id).length == 0" md12 class="body-2 text-xs-center pa-2 green--text">
                          Aprobado por Unanimidad
                        </v-flex>
                    </div>
                  </v-layout>
                </v-card>
              
              
                <v-divider class="mt-4"></v-divider>              
                <v-card flat>
                  <h2 class="headline ml-3 my-3"><v-icon color="grey lighten-1" medium>groups</v-icon> Asistencia</h2>

                  <v-data-table
                    v-if="assists_to_show"
                    :headers="headers"
                    :items="assists_to_show"
                    :loading="isLoading"
                    :items-per-page="5000"
                    :rows-per-page-text="$t('datatable.rowsPerPageText')"
                    :no-results-text="$t('datatable.noResultsText')"
                    :no-data-text="$t('datatable.noDataText')"
                    :rows-per-page-items="[{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.family_code }} - {{ props.item.family }}</td>
                      <td class="text-xs-center">
                        <v-icon v-show="props.item.asopaf === 1" small class="green--text text--lighten-2">
                          check_circle
                        </v-icon>
                      </td>
                      <td class="text-xs-center">
                        <v-icon v-show="props.item.employee === 1 || props.item.employee2 === 1" small class="green--text text--lighten-2">
                          check_circle
                        </v-icon>
                      </td>
                      <td class="text-xs-center">{{ props.item.powers_number > 0 ? props.item.powers_number : '' }}</td>
                      <td class="text-xs-left">{{ props.item.agent }}</td>
                      <td class="text-xs-left" style="overflow: hidden; text-overflow: ellipsis; max-width: 140px;">{{ props.item.notes }}</td>
                      <td class="text-xs-left">{{ props.item.assist_date }}</td>
                    </template>
                    <template v-slot:pageText="props">
                      {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
                    </template>
                  </v-data-table>
                </v-card>
          </v-card-text>
        </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'VirtualReportPrint',
  props: {
    assemblyId: {
      type: Number,
      required: true
    },
    assemblyResponse: {
      type: Object,
      required: true
    },
    questionsResponse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      appUrl: window.config.appUrl,
      loadingAssembly: null,
      isLoading: false,
      not_virtual: false,
      assemblyData: {},
      assemblyDocuments: {},
      answersDetail: {},
      
      questions: [],
      answers: [],
      idAssembly: null,
      currentTime: new Date(),
      diffAssembly: [],
      diffFinishAssembly: [],
      diffFirstCall: [],
      diffSecondCall: [],
      assemblyError: null,
      assemblyIsClosed: null,
      leftTime: -1,
      counter: 0,
      tabs: null,
      assemblyQuestions: [],
      assemblyAnswers: [],
      assemblyQuorum: {},

      actual_percent: 0,
      actual_eligible_percent: 0,
      total_families: 0,
      total_active_families: 0,
      total_active_asopaf_families: 0,
      total_atendance: 0,
      total_powers: 0,
      quorum: 0,
      total_employee: 0,
      total_employee_assistance: 0,
      total_asopaf: 0,
      total_asopaf_power: 0,
      total_asopaf_personal: 0,
      total_asopaf_assistance: 0,
      quorum_asopaf: 0,
      assists_to_show: [],
      headers: [
        { text: 'Familia', align: 'center', value: 'family', sortable: false},
        { text: 'ASOPAF', align: 'center', value: 'asopaf', sortable: false},
        { text: 'Empleado', align: 'center', value: 'employee', sortable: false},
        { text: '# poderes', align: 'center', value: 'powers_number', sortable: false},
        { text: 'Representante', align: 'center', value: 'agent', sortable: false},
        { text: 'IP', align: 'center', value: 'notes', sortable: false},
        { text: 'Fecha asistencia', align: 'center', value: 'name', sortable: false},
      ],
      answer_headers: [
        { text: 'Familia', value: 'family_code', sortable: false },
        { text: 'ASOPAF', value: 'asopaf', sortable: false },
        { text: 'Empleado', value: 'employee', sortable: false },
        { text: 'Representante', value: 'family_agent_code', sortable: false },
        { text: 'Respuesta', value: 'answer', sortable: false },
        { text: 'Fecha', value: 'created_at', sortable: false },
      ],
      search: '',
      total_assistance_to_quorum: 0,
      total_assistance_to_quorum_asopaf: 0,

      circleCharts: [],
      selectedQuestion: null,
      answer_detail: [],
      modalAnswerDetail: false,
    }
  },
  created(){
    this.$on('initPrintReport', this.init())
  },  
  computed: {
    ...mapGetters({
      pageLoading: 'pageLoading'
    }),
    getActualQuorum(){
      if (this.diffSecondCall[0] == '-'){
        return parseInt(this.total_active_families * this.assemblyData.min_percentage_first_call / 100, 0) + 1
      } else {
        return parseInt(this.total_active_families * this.assemblyData.min_percentage_second_call / 100, 0)
      }
    },
    getActualAsopafQuorum(){
      if (this.diffSecondCall[0] == '-'){
        return parseInt(this.total_active_asopaf_families * this.assemblyData.min_percentage_first_call / 100, 0) + 1
      } else {
        return parseInt(this.total_active_asopaf_families * this.assemblyData.min_percentage_second_call / 100, 0)
      }
    },
  },
  watch: {
    
  },
  methods: {
    init() {
      this.getAssembly()
      this.incrementCounter()
    },
    getAssembly(){
      let context = this
      const data = context.assemblyResponse;
      context.assemblyData = data.assembly;
      context.assemblyDocuments = data.documents;
      context.questions = data.questions.questions;
      context.answers = data.answers;
      context.quorum = data.quorum;
      context.delegated_powers_limit = data.assembly.delegated_powers_limit
      context.idAssembly = data.assembly.id;
      context.currentTime = new Date(data.current_time)
      context.diffAssembly = data.diff_assembly
      context.diffFinishAssembly = data.diff_finish_assembly
      context.diffFirstCall = data.diff_first_call
      context.diffSecondCall = data.diff_second_call

      let status = context.assemblyData.status
      context.actual_percent = status == 0 ? data.report.actual_percent : context.assemblyData.attendance_percentage;
      context.actual_eligible_percent = status == 0 ? data.report.actual_eligible_percent : context.assemblyData.actual_eligible_percent;
      context.total_families = status == 0 ? data.report.total_families : context.assemblyData.assembly_current_families;
      context.total_active_families = status == 0 ? data.report.total_active_families : (context.assemblyData.assembly_current_families - context.assemblyData.total_families_portfolio_entered);
      context.total_asopaf = status == 0 ? data.report.total_asopaf : context.assemblyData.assembly_current_asopaf_members;
      context.total_asopaf_assistance = status == 0 ? data.report.total_asopaf_assistance : context.assemblyData.attendance_asopaf;
      context.total_atendance = status == 0 ? data.report.total_assistance : context.assemblyData.attendance_families;
      context.total_powers = status == 0 ? data.report.total_powers_assistance : context.assemblyData.attendance_powers;
      context.quorum = data.report.quorum;
      context.total_employee = status == 0 ? data.report.total_employee : context.assemblyData.assembly_current_families_employee;
      context.total_employee_assistance = status == 0 ? data.report.total_employee_assistance : context.assemblyData.attendance_employees;
      context.total_asopaf_power = status == 0 ? data.report.total_asopaf_power : context.assemblyData.attendance_asopaf_pow;
      context.total_asopaf_personal = status == 0 ? data.report.total_asopaf_personal : context.assemblyData.attendance_asopaf_per;
      context.total_active_asopaf_families = context.total_asopaf - context.assemblyData.total_families_portfolio_asopaf_entered
      context.quorum_asopaf = data.report.total_asopaf_quorum;
      context.assists_to_show = data.report.assists
      context.total_assistance_to_quorum = data.report.total_assistance_to_quorum;
      context.total_assistance_to_quorum_asopaf = data.report.total_assistance_to_quorum_asopaf



      context.circleCharts = [
        { filter: 'all', type: 'circle', title: 'Asistencia', value: context.actual_percent + "%", color: 'teal', subtitle: context.total_atendance+" de "+context.total_families },
        { filter: 'all', type: 'circle', title: 'Q. Decisivo', value: context.total_atendance > context.getActualQuorum ? "100%" : parseInt(context.total_atendance/context.getActualQuorum * 100) + "%", color: context.total_atendance >= context.getActualQuorum ? 'purple lighten--2' : 'red', subtitle: context.total_atendance+' de '+context.getActualQuorum  },
        { filter: 'all', title: 'Personales', value: context.assemblyData.status === 0 ? context.total_atendance - context.total_powers : context.assemblyData.attendance_families - context.assemblyData.attendance_powers, color: '', subtitle: null, icon: 'assignment_ind' },
        { filter: 'all', title: 'Representados', value: context.total_powers, color: '', subtitle: null, icon: 'admin_panel_settings' },
        { filter: 'all', title: 'Total Familias', value: context.total_families, color: '', subtitle: null, icon: 'supervisor_account' },
        { filter: 'all', title: 'Familias Habilitadas', value: context.total_active_families, color: '', subtitle: null, icon: 'supervised_user_circle' },
        { filter: 'all', title: 'Asistencias', value: context.total_atendance, color: '', subtitle: null, icon: 'spellcheck'   },
        { filter: 'all', title: 'Empleados', value: context.total_employee, color: '', subtitle: null, icon: 'badge' },
        { filter: 'all', title: 'Asistencia Empleados', value: context.total_employee_assistance+'', color: '', subtitle: null, icon: 'family_restroom' },

        { filter: 'asopaf', type: 'circle', title: 'Asistencia', value: parseFloat(context.total_asopaf_assistance / context.total_asopaf * 100).toFixed(1) + "%", color: 'pink', subtitle: context.total_asopaf_assistance+" de "+context.total_asopaf },
        { filter: 'asopaf', type: 'circle', title: 'Q. Decisivo', value: context.total_asopaf_assistance > context.getActualAsopafQuorum ? "100%" : parseInt(context.total_asopaf_assistance/context.getActualAsopafQuorum * 100) + "%", color: context.total_asopaf_assistance >= context.getActualAsopafQuorum ? 'cyan lighten-1' : 'red', subtitle: context.total_asopaf_assistance+' de '+context.getActualAsopafQuorum },
        { filter: 'asopaf', title: 'Personales', value: context.total_asopaf_personal, color: '', subtitle: null, icon: 'assignment_ind' },
        { filter: 'asopaf', title: 'Representados', value: context.total_asopaf_power, color: '', subtitle: null, icon: 'admin_panel_settings' },
        { filter: 'asopaf', title: 'Total Familias', value: context.total_asopaf, color: '', subtitle: null, icon: 'supervisor_account' },
        { filter: 'asopaf', title: 'Familias Habilitadas', value: context.total_active_asopaf_families, color: '', subtitle: null, icon: 'supervised_user_circle' },
        { filter: 'asopaf', title: 'Asistencias', value: context.total_asopaf_assistance, color: '', subtitle: null, icon: 'spellcheck' },
      ]
      
      if (!data.documents){
        context.assemblyError = "No hay documentos de firma inscritos. Informe a soporte";
        context.isLoading = false
        return;
      }
      if (data.assembly.status == 0 || data.assembly.status == "0") {
        context.assemblyIsClosed = false;
      }
      context.getQuestions()
      context.getAnswers()
      context.loadingAssembly = false
      context.isLoading = false;
    },
    getQuestions() {
      const data = this.questionsResponse
      this.assemblyQuestions = data.questions
      this.assemblyAnswers = data.answers
      this.assemblyQuorum = data.real_quorum
    },
    formatTime(timeArray){
      let str = ''
      str += timeArray[0] == '-' ? 'en ' : 'hace '
      str += timeArray[1] != '0' ? timeArray[1]+' día' + (parseInt(timeArray[1]) > 1 ? 's ' : ' ') : ''
      str += timeArray[2] != '0' ? timeArray[2]+' hora' + (parseInt(timeArray[2]) > 1 ? 's ' : ' ') : ''
      str += timeArray[3] != '0' && timeArray[1] == '0' ? timeArray[3]+' minuto' + (parseInt(timeArray[3]) > 1 ? 's ' : ' ') : ''
      str += timeArray[4] != '0' && timeArray[2] == '0' && timeArray[3] == '0' ? timeArray[4]+' segundo' + (parseInt(timeArray[4]) > 1 ? 's' : '') : ''
      if (str.trim() == 'hace' || str.trim() == 'en') str = 'ahora'
      return str.trim()
    },
    showCounter(time, seconds=false){
      let current = new Date()
      if (this.currentTime > current){
          current = this.currentTime
      }
      let elapsed = (current.getTime() - moment(time).valueOf()) / 1000
      const diff = {};
      diff.days    = Math.abs(parseInt(elapsed / 86400))+"d";
      diff.hours   = Math.abs(parseInt(elapsed / 3600 % 24))+"h";
      diff.minutes = Math.abs(parseInt(elapsed / 60 % 60))+"m";
      diff.seconds = Math.abs(parseInt(elapsed % 60))+"s";
      let message = `${elapsed >= 0 ? 'hace' : 'en'} ${diff.days} ${diff.hours} ${diff.minutes} ${seconds ? diff.seconds : ''}`
      message = message.replace(" 0d", "").replace(" 0h", "").replace(" 0m", "").replace(" 0s", "").trim()
      if (message == 'hace' || message == 'en') message = 'ahora'
      return message
    },
    incrementCounter(){
      let current = new Date()
      if (this.currentTime > current){
          current = this.currentTime
      }
      setTimeout(() => {
        this.counter += 1
        this.incrementCounter()
        if (this.assemblyData && this.assemblyData.assembly_finish_time){
          this.leftTime = (current.getTime() - moment(this.assemblyData.assembly_date+' '+this.assemblyData.assembly_finish_time.substring(0,5)).valueOf()) / 1000
        }
      }, 15000); // each 15 second (update counters)
    },
    getTotalAnswer(question_id){
      let total = 0;
      this.assemblyAnswers.forEach(function(answerGrp){
        if(answerGrp.assemblyquestion_id == question_id){
          total += answerGrp.count
        }
      })
      return total
    },
    getAnswer(question_id, questiondetail_id){
      let total = 0;
      let count = 0;
      this.assemblyAnswers.forEach(function(answerGrp){
        if(answerGrp.assemblyquestion_id == question_id){
          total+= answerGrp.count
        }
        if(answerGrp.assemblyquestion_id == question_id && answerGrp.answer == questiondetail_id.toString()){
          count = answerGrp.count
        }
      })
      if (!total) total = 1
      let percent = (count/total * 100).toFixed(2);
      return `<b>${count}</b> : ${percent}% <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}" class="v-progress-linear" style="height: 12px; width: 100px; display: inline-flex; margin: 0px;">
                <div class="v-progress-linear__background primary" style="height: 12px; opacity: 0.3; width: 100%;"></div>
                <div class="v-progress-linear__bar">
                  <div class="v-progress-linear__bar__determinate primary" style="width: ${percent}%;"></div>
                </div>
              </div>`;
    },
    getAnswerDetail(question_id){
      if (Object.keys(this.answersDetail).length > 0){
          const question_ = this.answersDetail.filter(
          question => question.id == question_id
        )[0]
        return question_.answers
      } else {
        return [];
      }      
    },
    getAnswers(){
      this.isLoading = true
      let payload = { assembly_id: this.assemblyData.id }
      axios.post('/api/assemblyquestionsanswers/answers/all', payload)
        .then(response => 
        {
          this.isLoading = false
          this.answersDetail = response.data
        });
    }
  }
}
</script>
<style>

@media print {
  @page { 
    size: 210mm 297mm landscape;
  }
  body, .application, .container .v-card, .v-layout, .v-flex {
    background-color: transparent !important;
  }
  .v-navigation-drawer, footer.v-footer {
    display: none;
  }
  .v-toolbar, .theme--light.v-toolbar {
    display: block !important;
  }
  main.v-content {
    padding: 20px !important;
  }
  .report-container {
    width: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
  }
  .v-card, .elevation-2 {
    box-shadow: none !important;
  }
  .question-card {
    page-break-before: always !important;
  }
  .no-break {
    page-break-inside: avoid !important;
  }
  .no-print {
    display: none !important;
  }
  table.v-table tbody td, table.v-table tbody th {
    height: 30px;
  }
}
 a.v-tabs__item:hover {
  text-decoration: none !important;
  font-weight: bolder;
 }
 .v-chip {
   cursor: pointer;
 }
 </style>


// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/virtualreport-print.vue